import 'mdb-vue-ui-kit/css/mdb.min.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import i18n from "./i18n"
import VueResizeObserver from "vue-resize-observer";
import VueGtag from "vue-gtag";



import mitt from 'mitt';
const emitter = mitt();

//testing primevue
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/saga-blue/theme.css';      //theme
import 'primevue/resources/primevue.min.css';                //core css





/*import ProductZoomer from 'vue-product-zoomer'*/

const app = createApp(App)
      .use(store)
      .use(router)
      .use(i18n)

      /*.use(ProductZoomer)*/
      .use(VueResizeObserver)
      .use(VueGtag, { config: { id: "G-6QBNNYWGME" }})
     
//.use(ProductZoomer)

//testing primevue
.use(PrimeVue);

app.config.globalProperties.emitter = emitter
app.mount('#app');

window.app = app
